<template>
  <div class="SalesChart">
    <div class="chart">
      <canvas ref="chart" />
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import axios from "@/axios-client";

export default {
  data: function () {
    return {
      chart: null,
    };
  },
  methods: {
    fetchSales() {
      return axios
        .get("/report/dashboard-monthly-sales", {
          params: {
            begin_date: moment().startOf("year").format("YYYY-MM-DD"),
            end_date: moment().endOf("year").format("YYYY-MM-DD"),
          },
        })
        .then((response) => response.data.data)
        .then((sales) => {
          return sales.reduce(
            (monthlySales, sale) => {
              const monthIndex = moment(sale.sales_period).month(); // 20200401
              const amount = parseInt(sale.total_sales_amount); // 1700
              monthlySales.months[monthIndex] = amount;
              return monthlySales;
            },
            { months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
          );
        })
        .then((monthlySales) => monthlySales.months);
    },

    fetchTimeSpentAtClub() {
      return axios
        .get("/report/dashboard-time-spent-at-club", {
          params: {
            begin_date: moment().startOf("year").format("YYYY-MM-DD"),
            end_date: moment().endOf("year").format("YYYY-MM-DD"),
          },
        })
        .then((response) => response.data.data)
        .then((sales) => {
          return sales.reduce(
            (monthlyActivity, activity) => {
              const monthIndex = moment(activity.activity_period).month(); // 20200401
              const amount = parseInt(activity.total_activity_amount); // 36
              monthlyActivity.months[monthIndex] = amount;
              return monthlyActivity;
            },
            { months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
          );
        })
        .then((monthlyActivity) => monthlyActivity.months);
    },
  },
  mounted: async function () {
    const ctx = this.$refs.chart.getContext("2d");
    // const fillPattern = ctx.createLinearGradient(0, 0, 0, 350);
    // fillPattern.addColorStop(0, '#24136d')
    // fillPattern.addColorStop(0.85, '#b13468')
    // fillPattern.addColorStop(0.35, '#ef4266')

    const gradient = ctx.createLinearGradient(
      0,
      0,
      0,
      this.$refs.chart.height * 2
    );
    gradient.addColorStop(0, "#ef4266");
    gradient.addColorStop(1, "rgba(239, 66, 102, 0)");

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: new Date().getFullYear(),
            data: await this.fetchSales(),
            backgroundColor: gradient,
            borderColor: "#ef4266",
            pointBorderColor: "#ef4266",
            pointBackgroundColor: "#ef4266",
            pointHoverBackgroundColor: "#ef4266",
            pointHoverBorderColor: "#ef4266",
            borderWidth: 2,
            // fillGradientStartColor: '#ef4266',
            // fillGradientStopColor: 'rgba(239, 66, 102, 0)'
          },
          {
            label: "Hours spent at club",
            data: await this.fetchTimeSpentAtClub(),
            // backgroundColor: 'blue',
            borderColor: "blue",
            pointBorderColor: "blue",
            pointBackgroundColor: "blue",
            pointHoverBackgroundColor: "blue",
            pointHoverBorderColor: "blue",
            borderWidth: 2,
            // fillGradientStartColor: '#ef4266',
            // fillGradientStopColor: 'rgba(239, 66, 102, 0)'
          },
        ],
      },
      options: {
        defaultFontFamily: "MarkPro, sans-serif",
        responsive: true,
        maintainAspectRatio: false,
        showScale: false,
        onResize: (chart, size) => {
          console.log("onResize", size);
        },
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#f4f3f6",
            fontFamily: "MarkPro, sans-serif",
            fontSize: 10,
            padding: 20,
            usePointStyle: true,
          },
          onHover: function (e) {
            e.target.style.cursor = "pointer";
          },
          onLeave: function (e) {
            e.target.style.cursor = "default";
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "white",
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                display: true,
                fontColor: "rgba(255, 255, 255, 0.7)",
              },
              gridLines: {
                display: true,
                drawBorder: false,
                color: "rgba(255, 255, 255, 0.3)",
                borderDash: [1, 12],
              },
            },
          ],
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";

.SalesChart {
  display: flex;
  flex-direction: column;

  h4,
  h5 {
    text-transform: uppercase;
  }

  .filters {
    display: flex;
    justify-content: center;
    padding: 1em;

    select {
      background-color: rgba(0, 0, 0, 0);
      width: 6em;
      color: white;
    }
  }

  .chart {
    width: 100%;
    height: 400px;

    // background-image: linear-gradient(359deg, #24136d 100%, #b13468 -84%, var(--red-pink) -136%);
    // background-image: linear-gradient(359deg, #24136d 70%, #b13468, var(--red-pink));
    // background-image: linear-gradient(0deg,#0f003f,#b13468 150%,#ef4266 0);
    background-image: linear-gradient(
      0deg,
      var(--midnight-blue),
      #b13468 150%,
      var(--red-pink) 0
    );
    padding-bottom: 1em;

    canvas {
      padding: 1em;

      @include phone {
        padding: 0;
      }
    }
  }
}
</style>
